const actionTypes = {
  POST_SUPPORT: "APP_POST_SUPPORT",
  STORE_ALERTED: "APP_STORE_ALERTED",
  STORE_LOADING: "APP_STORE_LOADING",
  STORE_NOTIFICATION: "APP_STORE_NOTIFICATION",
  STORE_SETTINGS: "APP_STORE_SETTINGS",
};

export default actionTypes;
